<!--
  XXX  diff w/ src/components/Widgets/AssociateReports/AssociateActivityContainer.vue
-->
<template>
  <div class="h-100">
    <activity
      :entries="entries"
      title="Team Activity"
      :loading="loading"
    />
  </div>
</template>
<script>
import Activity from '@/components/Widgets/Reports/Activity';

export default {

  name: 'AdminActivityContainer',
  components: {
    Activity,
  },
  props: {
    dataRange: {
      type: String,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    stats() {
      if (!this.$store.state.institutions.item) {
        return { activity_stats: { periods: [], entries: [] } };
      }
      return this.$store.state.institutions.item;
    },
    entries() {
      if (!this.stats) {
        return [];
      }
      return [{
        label: 'Total Clients',
        value: this.stats.total_clients_range,
      }, {
        label: 'Book Penetration',
        value: this.stats.book_penetration,
        formatter: this.formatPercent,
      }, {
        label: 'Edits Created',
        value: this.stats.campaigns_range,
      }, {
        label: 'Emails Sent',
        value: this.stats.emails_sent_range,
      }, {
        label: 'PDFs Created',
        value: this.stats.pdfs_created,
      }, {
        label: 'Share Links Created',
        value: this.stats.links_created,
      }].map(({ label, value, formatter }) => {
        const formatted = formatter ? formatter(value) : this.formatGeneric(value);
        return {
          label,
          value: formatted,
        };
      });
    },
    loading() {
      return this.$store.state.institutions.isLoading;
    },
  },
  mounted() {
    this.$store.dispatch('profiles/fetchItem', this.$store.state.account.user.user.profile);
  },
  methods: {
    formatPercent(num) {
      return this.isNull(num) ? '--' : `${this.$options.filters.formatFloat(num * 100, 1)}%`;
    },
    isNull(value) {
      // eslint-disable-next-line
      return value === null || value === undefined || isNaN(value)
    },
    formatGeneric(value) {
      return this.isNull(value) ? '--' : value;
    },
  },
};
</script>
<style lang="css"
  scoped>
</style>
